<script setup lang="ts">
/**
 * The display to prompt the user to begin a search
 */
</script>

<template>
    <div class="empty-state-flex-centered" data-test="sp-results-prompt">
        <i class="icon-search"></i>
        <p>To begin searching, please enter a search term.</p>
    </div>
</template>

<style scoped></style>
